import { inject, observer } from 'mobx-react';
import * as React from 'react';

import { ITranslateStore } from '../../../stores/TranslateStore';
import BoxNotice from '../../common/BoxNotice';

interface ISuccessNoticeProps {
  translateStore?: ITranslateStore;
  translationKey: string;
}

@inject('translateStore')
@observer
export default class SuccessNotice extends React.Component<ISuccessNoticeProps> {
  public render(): JSX.Element {
    const translate = this.props.translateStore.translate;

    return <BoxNotice type="success">{translate(this.props.translationKey)}</BoxNotice>;
  }
}
